import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.

	// Main pages
	{
		path: "/",
		name: "home",
		component: () =>
			import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
		meta: {
			title: "Morfetik",
		},
	},
	{
		path: "/login",
		name: "login",
		component: () =>
			import(/* webpackChunkName: "login" */ "../views/LoginView.vue"),
		meta: {
			title: "Morfetik - Connexion",
		},
	},
	{
		path: "/search",
		name: "search",
		component: () =>
			import(/* webpackChunkName: "search" */ "../views/SearchView.vue"),
		meta: {
			title: "Morfetik - Recherche",
		},
	},
	{
		path: "/publications",
		name: "publications",
		component: () =>
			import(
				/* webpackChunkName: "publications" */ "../views/PublicationsView.vue"
			),
		meta: {
			title: "Morfetik - Publications",
		},
	},
	{
		path: "/about",
		name: "about",
		meta: {
			title: "Morfetik - À propos",
		},
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
	},
	{
		path: "/edition",
		name: "edition",
		component: () =>
			import(
				/* webpackChunkName: "edition" */ "../views/edition/EditionMenuView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},

	{
		path: "/edition/simple-adjectives",
		name: "simple-adjectives",
		component: () =>
			import(
				/* webpackChunkName: "simple-adjectives" */ "../views/edition/lemmes/AdjectivesView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/composed-adjectives",
		name: "composed-adjectives",
		component: () =>
			import(
				/* webpackChunkName: "composed-adjectives" */ "../views/edition/lemmes/AdjectivesCompView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/simple-noms",
		name: "simple-noms",
		component: () =>
			import(
				/* webpackChunkName: "simple-noms" */ "../views/edition/lemmes/NounsView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/composed-noms",
		name: "composed-noms",
		component: () =>
			import(
				/* webpackChunkName: "composed-noms" */ "../views/edition/lemmes/NounsCompView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/verbes",
		name: "verbes",
		component: () =>
			import(
				/* webpackChunkName: "verbes" */ "../views/edition/lemmes/VerbsView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/adverbes",
		name: "adverbes",
		component: () =>
			import(
				/* webpackChunkName: "adverbes" */ "../views/edition/lemmes/AdverbsView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/determinants",
		name: "determinants",
		component: () =>
			import(
				/* webpackChunkName: "determinants" */ "../views/edition/lemmes/SpecifiersView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/pronoms",
		name: "pronoms",
		component: () =>
			import(
				/* webpackChunkName: "pronoms" */ "../views/edition/lemmes/PronounsView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/autres",
		name: "autres",
		component: () =>
			import(
				/* webpackChunkName: "autres" */ "../views/edition/lemmes/OthersView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/codes/adjectives",
		name: "adjectives-codes",
		component: () =>
			import(
				/* webpackChunkName: "adjectives-codes" */ "../views/edition/codes/AdjectivesCodesView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/codes/nouns",
		name: "nouns-codes",
		component: () =>
			import(
				/* webpackChunkName: "nouns-codes" */ "../views/edition/codes/NounsCodesView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/codes/verbs",
		name: "verbs-codes",
		component: () =>
			import(
				/* webpackChunkName: "verbs-codes" */ "../views/edition/codes/VerbsCodesView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/souscat/adjectives",
		name: "adjectives-souscat",
		component: () =>
			import(
				/* webpackChunkName: "adjectives-souscat" */ "../views/edition/config/souscat/AdjectivesSouscatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/souscat/nouns",
		name: "nouns-souscat",
		component: () =>
			import(
				/* webpackChunkName: "nouns-souscat" */ "../views/edition/config/souscat/NounsSouscatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/souscat/verbs",
		name: "verbs-souscat",
		component: () =>
			import(
				/* webpackChunkName: "verbs-souscat" */ "../views/edition/config/souscat/VerbsSouscatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/souscat/specifiers",
		name: "specifiers-souscat",
		component: () =>
			import(
				/* webpackChunkName: "specifiers-souscat" */ "../views/edition/config/souscat/SpecifiersSouscatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/cat/pronouns",
		name: "pronouns-cat",
		component: () =>
			import(
				/* webpackChunkName: "pronouns-cat" */ "../views/edition/config/cat/PronounsCatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/cat/specifiers",
		name: "specifiers-cat",
		component: () =>
			import(
				/* webpackChunkName: "specifiers-cat" */ "../views/edition/config/cat/SpecifiersCatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/souscat/pronouns",
		name: "pronouns-souscat",
		component: () =>
			import(
				/* webpackChunkName: "pronouns-souscat" */ "../views/edition/config/souscat/PronounsSouscatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/souscat/adverbs",
		name: "adverbs-souscat",
		component: () =>
			import(
				/* webpackChunkName: "adverbs-souscat" */ "../views/edition/config/souscat/AdverbsSouscatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/cat/others",
		name: "others-cat",
		component: () =>
			import(
				/* webpackChunkName: "others-cat" */ "../views/edition/config/cat/OthersCatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/souscat/others",
		name: "others-souscat",
		component: () =>
			import(
				/* webpackChunkName: "others-souscat" */ "../views/edition/config/souscat/OthersSouscatView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/config/domains",
		name: "domains",
		component: () =>
			import(
				/* webpackChunkName: "domains" */ "../views/edition/config/DomainsView.vue"
			),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/autres/publications",
		name: "publications-edition",
		component: () =>
			import(/* webpackChunkName: "publications-edition" */ "../views/edition/autres/publicationArticle.vue"),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/autres/financements",
		name: "financements",
		component: () =>
			import(/* webpackChunkName: "financements" */ "../views/edition/autres/financements.vue"),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/edition/autres/guide-utilisation",
		name: "guide-utilisation",
		component: () =>
			import(/* webpackChunkName: "guide-utilisation" */ "../views/edition/autres/guideUtilisation.vue"),
		meta: {
			title: "Morfetik - Édition",
		},
	},
	{
		path: "/users",
		name: "users",
		component: () =>
			import(/* webpackChunkName: "users" */ "../views/admin/UsersView.vue"),
		meta: {
			title: "Morfetik - Gestion des utilisateurs",
		},
	},
	{
		path: "/profile",
		name: "profile",
		component: () =>
			import(/* webpackChunkName: "profile" */ "../views/ProfileView.vue"),
		meta: {
			title: "Morfetik - Profil",
		},
	},
	{
		path: "/*",
		name: "not-found",
		component: () =>
			import(/* webpackChunkName: "not-found" */ "../components/NotFound.vue"),
		meta: {
			title: "Morfetik - Erreur 404",
		},
	},
]

const router = new VueRouter({
	routes,
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
	// This goes through the matched routes from last to first, finding the closest route with a title.
	// e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
	// `/nested`'s will be chosen.
	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title)

	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags)

	const previousNearestWithMeta = from.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags)

	// If a route with a title was found, set the document (page) title to that value.
	if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title
	} else if (previousNearestWithMeta) {
		document.title = previousNearestWithMeta.meta.title
	}

	// Remove any stale meta tags from the document using the key attribute we set below.
	Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
		(el) => el.parentNode.removeChild(el)
	)

	// Skip rendering meta tags if there are none.
	if (!nearestWithMeta) return next()

	// Turn the meta tag definitions into actual elements in the head.
	nearestWithMeta.meta.metaTags
		.map((tagDef) => {
			const tag = document.createElement("meta")

			Object.keys(tagDef).forEach((key) => {
				tag.setAttribute(key, tagDef[key])
			})

			// We use this to track which meta tags we create so we don't interfere with other ones.
			tag.setAttribute("data-vue-router-controlled", "")

			return tag
		})
		// Add the meta tags to the document head.
		.forEach((tag) => document.head.appendChild(tag))

	next()
})

router.beforeEach((to, from, next) => {
	const publicPages = ["/login", "/about", "/", "/publications", "/search"]
	const authRequired = !publicPages.includes(to.path)
	const loggedIn = localStorage.getItem("user")
	// trying to access a restricted page + not logged in
	// redirect to login page
	if (authRequired && !loggedIn) {
		next("/login")
	} else {
		next()
	}
})

export default router
